/**
 * VAT (Value Added Tax) constants and helpers.
 *
 * 🔻 **RETAINED BUT NOT REACHED — THE VAT DISPLAY WAS REMOVED FROM THE UI ON
 * 2026-08-08.** `hooks/useVatMode.js` now binds `includeVat` to a hard `false`,
 * so `applyVatIfNeeded` is called only with `false` and returns its input
 * unchanged. This file is kept deliberately (product owner: *"Kepe the code but
 * remove vat for now"*) and the reason for the removal is recorded in full in
 * that hook. **Read it before wiring any of this back up.**
 *
 * 🚨 **THE PREVIOUS HEADER SAID "Crew Forge stores all monetary values Ex VAT
 * (the user contract for input fields is 'type Ex VAT')". THAT IS NO LONGER
 * TRUE AND IS THE MOST IMPORTANT CORRECTION IN THIS FILE.** The product decision
 * is that each DEPARTMENT chooses whether it enters ex- or inc-VAT prices, and
 * **nothing in the schema records which choice a department made.** So a stored
 * figure means "the number somebody typed" and no code may assume otherwise —
 * which is why every "(Ex VAT)" label was removed rather than merely hidden.
 *
 * ⚠️ **AND THE OLD SUGGESTION BELOW WAS THE FEATURE'S ACTUAL DEFECT, so it is
 * recorded here as a warning rather than deleted.** It read: *"If we ever need
 * configurable rates per production, change VAT_RATE to a function reading from
 * the production row."* A rate **per production** is exactly the wrong shape and
 * is what got the feature pulled: UK rates (standard 20%, reduced 5%,
 * zero-rated, exempt) vary **per LINE ITEM**, and one order routinely mixes
 * them. A per-production rate is the same category error as the per-production
 * boolean, just with more digits. Any real implementation needs a rate carried
 * by the item.
 */
export const VAT_RATE = 0.20;

/**
 * Uplift an amount by VAT when the active production is in Inc VAT mode.
 * Returns the bare numeric amount when includeVat is falsy.
 * Handles null/undefined/NaN gracefully (coerced to 0).
 */
export function applyVatIfNeeded(amount, includeVat) {
  const n = Number(amount);
  const safe = Number.isFinite(n) ? n : 0;
  return includeVat ? safe * (1 + VAT_RATE) : safe;
}
